import TcApiCart from './tc-api/cart';
import TcApiLocalization from './tc-api/localization';
import TcApiCustomer from './tc-api/customer';
/**
 * Public JS API which is available from any third party scripts which are not managed by application itself.
 * API is accessible through window.tcApi() object.
 *
 * Warning: when modifying this class, please make sure that you are not breaking any existing functionality.
 */
export default class TcApi {
    constructor() {
        this.cart = new TcApiCart();
        this.localization = null;
        this.customer = new TcApiCustomer();
        this.loadTimeout = 5;
        window.publicTcApi = this;
        if (typeof window.__STATE__ !== 'undefined') {
            this.localization = new TcApiLocalization(window.__STATE__.localization);
            window.dispatchEvent(new CustomEvent('tc-api-ready'));
        }
        else {
            // czekamy aż window.__STATE__ zostanie zainicjalizowany
            // po 5 sekundach wyrzucamy błąd w konsoli, cały czas sprawdzając inicjalizajcę window.__STATE__
            let counter = 0;
            const interval = setInterval(() => {
                if (typeof window.__STATE__ !== 'undefined') {
                    this.localization = new TcApiLocalization(window.__STATE__.localization);
                    window.dispatchEvent(new CustomEvent('tc-api-ready'));
                    clearInterval(interval);
                }
                if (counter === this.loadTimeout * 10) {
                    console.error('TcApi: window.__STATE__ is not defined');
                }
                counter++;
            }, 100);
        }
    }
}
